import { ConnectionTypes } from 'calling-cross-tab-library/types/ConnectionTypes';
import { UUID } from 'shared-worker-versioning/lib/utils/UUID';
export class _CrossTabConfig {
  constructor() {
    this._crossTabConfig = {
      connectionId: UUID('callingConnectionId'),
      connectionType: ConnectionTypes.EXTERNAL,
      broadcastMessageHandlers: [],
      isLoadingStarted: false,
      sharedWorkerConnectionSingletonPromise: undefined
    };
    this.get = () => this._crossTabConfig;
    this.setConnectionType = type => {
      this._crossTabConfig.connectionType = type;
    };
  }
}
export default new _CrossTabConfig();